import { InputTypes } from 'Components-redesign/Form/fieldTypes';

export const getUpsellFormFields = (t, idToUpdate, itemsList) => [
  {
    id: 'name',
    label: t('General.Name'),
    type: InputTypes.TEXTLANG,
    placeHolder: t('PIM.NamePlaceholder'),
    mandatory: true,
  },
  {
    id: 'displayOrder',
    label: t('General.Order'),
    type: InputTypes.INT,
    mandatory: false,
  },
  {
    id: 'enableMultiSelect',
    label: t('PIM.Upsell.enableMultiSelect'),
    type: InputTypes.TOGGLE,
    mandatory: false,
    customMutation: () => {
      // This is to skip the mutation of this field, as it is handled in a different way
      return;
    },
  },
  {
    id: 'hideInPOS',
    label: 'Hide in POS',
    type: InputTypes.TOGGLE,
    mandatory: false,
    customMutation: () => {
      // This is to skip the mutation of this field, as it is handled in a different way
      return;
    },
  },
  {
    id: 'hideInEPOS',
    label: 'Hide in Express',
    type: InputTypes.TOGGLE,
    mandatory: false,
    customMutation: () => {
      // This is to skip the mutation of this field, as it is handled in a different way
      return;
    },
  },
  {
    id: 'hideInApp',
    label: 'Hide in App',
    type: InputTypes.TOGGLE,
    mandatory: false,
    customMutation: () => {
      // This is to skip the mutation of this field, as it is handled in a different way
      return;
    },
  },
  {
    id: 'items',
    type: InputTypes.FIELDSELECTLIST,
    idToUpdate,
    list: itemsList,
    customMutation: (val) => {
      if (!val) return;

      return idToUpdate
        ? { set: val.map((val) => ({ id: val.id })) }
        : { connect: val.map((val) => ({ id: val.id })) };
    },
  },
  {
    id: 'itemsUsedOn',
    label: t('PIM.ItemsUsedOnUpsell'),
    type: InputTypes.FIELDSELECTLIST,
    idToUpdate,
    list: itemsList,
    customMutation: (val) => {
      if (!val) return;

      return idToUpdate
        ? { set: val.map((val) => ({ id: val.id })) }
        : { connect: val.map((val) => ({ id: val.id })) };
    },
  },
];
